import { render, staticRenderFns } from "./NotFoundComponent.vue?vue&type=template&id=2c6d6d6c&scoped=true&"
var script = {}
import style0 from "./NotFoundComponent.vue?vue&type=style&index=0&id=2c6d6d6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6d6d6c",
  null
  
)

export default component.exports